export const GET_MEMBER_TRANSACTION_START =
  'GET_MEMBER_TRANSACTION_START';
export const GET_MEMBER_TRANSACTION_SUCCESS =
  'GET_MEMBER_TRANSACTION_SUCCESS';
export const GET_MEMBER_TRANSACTION_ERROR =
  'GET_MEMBER_TRANSACTION_ERROR';
